<template>
    <div>
        <v-text-field
            v-model="search"
            prepend-inner-icon="mdi-magnify"
            label="Buscar dashboard"
            dense
            outlined
            clearable
            hide-details
            class="mb-2"
        />
        <div class="caption grey--text mb-3">{{ selectedCount }} de {{ charts.length }} selecionados</div>

        <v-card outlined>
            <v-list>
                <template v-for="(chart, idx) in filteredCharts">
                    <v-divider v-if="idx > 0" :key="'d-' + chart.id" />
                    <v-list-item :key="chart.id">
                        <v-list-item-content>
                            <v-list-item-title>{{ chart.name }}</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                            <v-switch
                                v-model="selected"
                                :value="chart.id"
                                color="green darken-2"
                                hide-details
                                dense
                                class="pa-0 ma-0"
                                @change="apply"
                            />
                        </v-list-item-action>
                    </v-list-item>
                </template>
            </v-list>
            <div v-if="!filteredCharts.length" class="text-center grey--text py-4 caption">Nenhum dashboard encontrado.</div>
        </v-card>
    </div>
</template>

<script setup>

import { defineProps, defineEmits, ref, computed, watch, onBeforeMount } from 'vue'
import { useStore } from '@/composables/useStore'

const store = useStore()

const props = defineProps({
    value: { type: Array, default: () => [] }
})
const emit = defineEmits(['input'])

const charts = ref([])
const search = ref('')
const selected = ref([...(props.value || [])])

watch(() => props.value, (val) => {
    const next = [...(val || [])]
    if (JSON.stringify(next) !== JSON.stringify(selected.value)) selected.value = next
})

const apply = () => emit('input', [...selected.value])

const chartIds = computed(() => charts.value.map((c) => c.id))
const selectedCount = computed(() => selected.value.filter((id) => chartIds.value.includes(id)).length)

const filteredCharts = computed(() => {
    const term = (search.value || '').toLowerCase()
    if (!term) return charts.value
    return charts.value.filter((c) => (c.name || '').toLowerCase().includes(term))
})

onBeforeMount(async () => {
    const res = await store.dispatch('chart/ActionFindCharts')
    charts.value = res.data || []
})

</script>
